export const DEFAULT_DISCORD_INVITE_URL = "https://discord.gg/eXduKXZ3";

export function getDiscordInviteUrlFromPayload(payload) {
  const discordInviteUrl =
    typeof payload?.discordInviteUrl === "string"
      ? payload.discordInviteUrl.trim()
      : "";

  return discordInviteUrl || DEFAULT_DISCORD_INVITE_URL;
}

export async function fetchPublicDiscordInviteUrl(basePath, fetchImpl) {
  const runFetch = fetchImpl || fetch;
  const response = await runFetch(`${basePath}/api/v1/public/discord-invite`);
  const payload = await response.json();
  return getDiscordInviteUrlFromPayload(payload);
}
